import { render, staticRenderFns } from "./Staging.vue?vue&type=template&id=2a1e4473&scoped=true&"
import script from "./Staging.vue?vue&type=script&lang=ts&"
export * from "./Staging.vue?vue&type=script&lang=ts&"
import style0 from "./Staging.vue?vue&type=style&index=0&id=2a1e4473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e4473",
  null
  
)

export default component.exports